module.exports = __webpack_public_path__ + "static/img/forests08.6a361ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/forests08.jpg
// module id = Ur5S
// module chunks = 0